var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9617 11.8921H11.9927C14.8247 11.8921 17.1287 9.58814 17.1287 6.75614C17.1287 3.92414 14.8247 1.61914 11.9927 1.61914C9.15975 1.61914 6.85575 3.92414 6.85575 6.75314C6.85075 8.12214 7.37975 9.41014 8.34375 10.3811C9.30675 11.3511 10.5917 11.8881 11.9617 11.8921ZM8.35575 6.75614C8.35575 4.75114 9.98775 3.11914 11.9927 3.11914C13.9977 3.11914 15.6287 4.75114 15.6287 6.75614C15.6287 8.76114 13.9977 10.3921 11.9927 10.3921H11.9647C10.9967 10.3901 10.0897 10.0101 9.40775 9.32314C8.72575 8.63714 8.35275 7.72614 8.35575 6.75614Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40552 18.7561C4.40552 22.3811 10.1215 22.3811 11.9995 22.3811C13.8775 22.3811 19.5945 22.3811 19.5945 18.7341C19.5945 15.9411 16.1165 13.5811 11.9995 13.5811C7.88352 13.5811 4.40552 15.9511 4.40552 18.7561ZM5.90552 18.7561C5.90552 17.0211 8.51152 15.0811 11.9995 15.0811C15.4885 15.0811 18.0945 17.0101 18.0945 18.7341C18.0945 20.1581 16.0435 20.8811 11.9995 20.8811C7.95652 20.8811 5.90552 20.1661 5.90552 18.7561Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.10669a48798904a22ceb638712dae78d.svg";
export { ForwardRef as ReactComponent };